import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleGetInvolvedClick = (e) => {
    e.preventDefault();
    setIsDropdownOpen(false);
    
    if (location.pathname === '/') {
      // If already on home page, scroll to section
      setTimeout(() => {
        const element = document.getElementById('get-involved');
        if (element) {
          const headerOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 50);
    } else {
      // Navigate to home page, hash will be handled by the home page's useEffect
      navigate('/#get-involved');
    }
  };

  return (
    <header className="ul-header">
      <div className={`ul-header-bottom to-be-sticky ${isScrolled ? 'sticky' : ''}`}>
        <div className="ul-header-bottom-wrapper ul-header-container">
          <div className="logo-container">
            <Link to="/" className="d-inline-block">
              <img src="/assets/logo_new.png" alt="logo" className="logo" />
            </Link>
          </div>

          <div className="ul-header-nav-wrapper">
            <div className="to-go-to-sidebar-in-mobile">
              <nav className="ul-header-nav">
                <Link to="/" className="nav-link">Home</Link>
                <Link to="/about" className="nav-link">About</Link>
                <Link to="/team" className="nav-link">Team</Link>
                <Link to="/blog" className="nav-link">Pathway Guides</Link>
                <Link to="/pathio-buddies" className="nav-link">Pathio Buddies</Link>
                <div 
                  className="has-sub-menu"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}
                >
                  <button 
                    className="nav-link nav-dropdown-toggle"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    aria-expanded={isDropdownOpen}
                  >
                    Get Involved
                    <i className="flaticon-down-arrow"></i>
                  </button>
                  <div className={`ul-header-submenu ${isDropdownOpen ? 'active' : ''}`}>
                    <ul>
                      <li><a href="#get-involved" onClick={handleGetInvolvedClick}>Why We Need You</a></li>
                      <li><Link to="/contact" onClick={() => setIsDropdownOpen(false)}>Contact</Link></li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>

          <div className="ul-header-actions">
            <Link to="/donate" className="ul-btn d-none d-lg-inline-flex" aria-label="Donate">
              <i className="flaticon-fast-forward-double-right-arrows-symbol"></i>
              Donate
            </Link>
            <button
              className="ul-header-sidebar-opener d-lg-none d-inline-flex"
              aria-label="Toggle menu"
              onClick={() => {
                const sb = document.querySelector('.ul-sidebar');
                if (sb) sb.classList.toggle('active');
              }}
            >
              <i className="flaticon-menu"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

